import {animate, state, style, transition, trigger} from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import {GtmService} from 'src/app/services/gtm.service';
import {EventActionEnum, EventCategoryEnum} from 'src/app/enums/GaTrackingEnums';
import {GtmEventEnum} from 'src/app/enums/GoogleEnums';
import {SearchWidgetData} from 'src/app/types/SearchWidgetData';
import {SearchWidgetThemeEnum} from '../../enums/search-widget-theme.enum';
import {AppConfigService} from '../../../../services/app-config.service';
import {SearchService} from '../../../../services/search/search.service';
import {Router} from '@angular/router';
import {QueryParams} from '../../../../types/QueryParams';
import {SearchReloadService} from '../../../../services/search/search-reload.service';

@Component({
  selector: 'app-mega-menu-desktop',
  templateUrl: './mega-menu-desktop.component.html',
  styleUrls: ['./mega-menu-desktop.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [trigger('fade', [state('void', style({opacity: 0})), transition('void <=> *', animate(300))])],
})
export class MegaMenuDesktopComponent {
  public theme = input<SearchWidgetThemeEnum>(SearchWidgetThemeEnum.DEFAULT);
  public onMegaMenuClick = output<undefined>();

  public menuItems = signal<string[]>(['Sök Vårdgivare']);
  public selectedItemIndex = signal<number>(0);
  private searchService = inject(SearchService);
  protected megaMenuDesktopOpen = this.searchService.megaMenuDesktopOpen;
  private handledWidgetData = this.searchService.searchWidgetData;
  public widgetData = computed<SearchWidgetData>(() =>
    this.searchService.updateWidgetDataWithRouterLinks(this.handledWidgetData()),
  );

  constructor(
    public appConfigService: AppConfigService,
    private gtmService: GtmService,
    private readonly router: Router,
    private reloadService: SearchReloadService,
  ) {
    if (this.appConfigService.appConfig.features.enableCareServicesInMegaMenu) {
      this.menuItems.update((items) => [...items, 'Sök Behandling']);
    }
    if (this.appConfigService.appConfig.features.enableSymptomsInMegaMenu) {
      this.menuItems.update((items) => [...items, 'Sök Symptom']);
    }
  }

  public selectMenuItem(index: number) {
    const gtmTag = {
      event: GtmEventEnum.DEFAULT,
      Category: EventCategoryEnum.SEARCHNAV,
      Action: EventActionEnum.MENU_ITEM_CLICK,
      Label: 'click',
      Value: 1,
    };
    this.gtmService.pushTag(gtmTag);
    this.selectedItemIndex.set(index);
  }

  public selectItem(routerLink?: string[], queryParams?: QueryParams, doJsRedirect?: boolean) {
    let action: string;

    switch (this.selectedItemIndex()) {
      case 0:
        action = EventActionEnum.CARE_SERVICE_CLICK;
        break;
      case 1:
        action = EventActionEnum.CARE_SERVICE_TYPE_CLICK;
        break;
      case 2:
        action = EventActionEnum.SYMPTOM_CLICK;
        break;
    }

    const gtmTag = {
      event: GtmEventEnum.DEFAULT,
      Category: EventCategoryEnum.SEARCHNAV,
      Action: action,
      Label: 'click',
      Value: 1,
    };

    this.gtmService.pushTag(gtmTag);

    this.toggle();
    this.reloadService.reload(routerLink, queryParams);
    if (doJsRedirect === true) {
      this.router.navigate(routerLink, {queryParams});
    }
  }

  public toggle() {
    this.onMegaMenuClick.emit(undefined);
  }
}
